import React,{useEffect,useState} from 'react';
import QRCode from 'qrcode';
import './SponsorQR.scss';

export const sponsorUrl=(value?:string)=>!value?'':/^[a-z][a-z\d+.-]*:\/\//i.test(value)?value:`https://${value}`;
export default function SponsorQR({value,className=''}:{value:string;className?:string}){const [svg,setSvg]=useState('');useEffect(()=>{QRCode.toString(value,{type:'svg',margin:0,errorCorrectionLevel:'M',color:{dark:'#071827',light:'#ffffff'}}).then(setSvg).catch(()=>setSvg(''));},[value]);return svg?<i className={`sponsorQr ${className}`} dangerouslySetInnerHTML={{__html:svg}}/>:null;}
